import { render, staticRenderFns } from "./site.vue?vue&type=template&id=ba84bce2&"
import script from "./site.vue?vue&type=script&lang=js&"
export * from "./site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports